module.exports = __webpack_public_path__ + "fonts/F37Moon-Regular.6da2fd6.otf";